<script setup lang="ts">
  import { useField } from 'vee-validate';
  import type { FormFieldProps } from '~/models/form-field';
  import { computed } from 'vue';

  const { name, value, type, rules } = defineProps<FormFieldProps>();

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta
  } = useField(name, rules, {
    initialValue: value
  });

  const isRequired = computed(() => typeof rules === 'string' && rules.includes('required'));
</script>

<template>
  <div
    :class="[
      'form-field',
      {
        'form-field--error': !!errorMessage,
        'form-field--success': meta.valid
      }
    ]">
    <div class="form-field__wrapper">
      <input
        :id="name"
        :type="type"
        :name="name"
        :placeholder="placeholder ?? ''"
        :maxlength="maxlength"
        :value="inputValue"
        class="form-field__input"
        formnovalidate
        @input="handleChange"
        @blur="handleBlur" />
      <label
        :for="name"
        class="form-field__label">
        {{ label }}
        <span v-if="isRequired">*</span>
      </label>
    </div>
    <div
      v-if="errorMessage"
      class="form-field__error">
      <span />
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>
